var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AiTaggingRepository } from '../repositories/ai-tagging-repository.interface';
let TaggingServiceImpl = class TaggingServiceImpl {
    constructor(_aiTaggingRepository) {
        this._aiTaggingRepository = _aiTaggingRepository;
    }
    startTagging(params) {
        return this._aiTaggingRepository.startTagging(params);
    }
    getTaggingResult(params) {
        return this._aiTaggingRepository.getTaggingResult(params);
    }
    cancelTagging(params) {
        return this._aiTaggingRepository.cancelTagging(params);
    }
};
TaggingServiceImpl = __decorate([
    injectable(),
    __param(0, inject(AiTaggingRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof AiTaggingRepository !== "undefined" && AiTaggingRepository) === "function" ? _a : Object])
], TaggingServiceImpl);
export { TaggingServiceImpl };
